<template>
  <div class="h-100 mx-auto d-flex align-items-center justify-content-lg-center flex-column" style="max-width:480px;">
    <div class="w-100 flex-grow-1 flex-lg-grow-0 mb-lg-5 d-flex flex-column justify-content-center align-items-center">
      <div class="h5" style="color:#22BA4F;">{{ $t("qrcode.addfriendwording") }}</div>
      <div class="h5" style="color:#22BA4F;">{{ $t("qrcode.addfriendwording1") }}</div>
      <img src="@/assets/images/illustration/undraw_truelove.svg" alt="" class="w-100 my-3" style="max-width:320px;">
    </div>
    <div class="w-100 p-3 text-center position-sticky" style="bottom:0;">
      <b-button class="py-3 px-5 font-weight-bold" block style="background-color:#22BA4F;border-color:#22BA4F;" @click="goToOfficalAccount()">{{ $t("qrcode.addfriend") }}</b-button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    // 導頁 url
    redirectUrl: String,
  },
  computed: {
  },
  methods: {
    // 前往官方帳號
    goToOfficalAccount() {
      window.location.assign(this.redirectUrl);
    },
  },
};
</script>
